import { VersionCard } from "./version-card"

export const VersionHistoryContent = ({ videoVersionHistory, handleStatusChange }) => {
  const maxVersionsReached = videoVersionHistory && videoVersionHistory.videoVersions && videoVersionHistory.videoVersions.length >= 3 && !videoVersionHistory.videoVersions.some(v => v.status === 'Approved');
  return (
    <div className="space-y-6">
      {maxVersionsReached && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
          <p className="text-amber-800 font-medium">
            ⚠️ Maximum 3 versions reached without approval. Please review
            existing versions.
          </p>
        </div>
      )}

      <div className="space-y-6">
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-gray-900">
            Version History
          </h3>
          {videoVersionHistory && videoVersionHistory.videoVersions && videoVersionHistory.videoVersions.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No versions uploaded yet.
            </div>
          ) : (
            videoVersionHistory && videoVersionHistory.videoVersions.map(version => (
              <VersionCard videoVersion={version} handleStatusChange={handleStatusChange}/>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
